/**
 * Extracts venue ID from either a direct ID or slug
 * @param venueIdOrSlug - Either a venue ID (number) or venue slug (string)
 * @param host - The host URL for API calls
 * @returns Promise<number | null> - The venue ID or null if not found/error
 */
export const extractVenueId = async (
  venueIdOrSlug: string | number,
  host: string
): Promise<number | null> => {
  // Branch 1: Direct venue ID provided
  if (typeof venueIdOrSlug === "number") {
    return venueIdOrSlug;
  }

  // Branch 2: Check if string is numeric ID
  const parsedId = parseInt(venueIdOrSlug, 10);
  if (!Number.isNaN(parsedId) && parsedId.toString() === venueIdOrSlug) {
    return parsedId;
  }

  // Branch 3: It's a slug, need to fetch venue to get ID
  try {
    const response = await fetch(
      `${host}/api/public/venues/${venueIdOrSlug}/`,
      {
        method: "GET",
        credentials: "include",
      }
    );
    if (response.ok) {
      const venue = await response.json();
      return venue.id ?? null;
    }
    // API call failed - return null
    return null;
  } catch (error) {
    // Network/fetch error - return null
    return null;
  }
};
